var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudOff = function SvgCloudOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.277 2.176a.6.6 0 0 1 .847 0l18.703 18.702a.6.6 0 0 1-.848.848l-2.548-2.548a4.9 4.9 0 0 1-1.277.174H9.5a7.4 7.4 0 0 1-4.356-13.46L2.277 3.022a.6.6 0 0 1 0-.847m3.732 4.58a6.2 6.2 0 0 0-2.608 6.794 6.2 6.2 0 0 0 6.09 4.602h7.66q.122-.002.242-.012zm4.132-2.203a7.4 7.4 0 0 1 6.39 5.098h.622a4.85 4.85 0 0 1 4.471 6.742.6.6 0 0 1-.977.19L9.663 5.574a.601.601 0 0 1 .478-1.021m10.63 10.455q.06-.42.021-.844a3.65 3.65 0 0 0-1.91-2.88 3.65 3.65 0 0 0-1.728-.433h-.53zm-5.639-5.652a6.2 6.2 0 0 0-3.062-3.069z"
  })));
};
export default SvgCloudOff;